<template>
  <div>
    <a-modal :visible="visible" :title="title" okText="确认" cancelText="取消" :afterClose="afterClose"
      @cancel="$emit('cancel')" @ok="handleSubmit" :maskClosable="false">
      <a-form :form="form">
        <h5>场景名称</h5>
        <a-form-item>
          <a-input 
            v-decorator="['sceneName', { rules: [{ required: true, message: '请输入场景名称' }] }]"
          />
        </a-form-item>
        <h5>上传封面图</h5>
        <a-upload
          name="file"
          :multiple="false"
          :action="$api.uploadUrl"
          list-type="picture"
          :headers="headers"
          :data="otherParams"
          @change="(e) => handleChange(e, 'cover')"
          :file-list="fileListCover"
        >
          <a-button> <a-icon type="upload" /> 上传图片 </a-button>
        </a-upload>
        <br>
        <h5>上传预览图</h5>
        <a-upload
          name="file"
          :multiple="false"
          :action="$api.uploadUrl"
          list-type="picture"
          :headers="headers"
          :data="otherParams"
          @change="(e) => handleChange(e, 'preview')"
          :file-list="fileListPreview"
        >
          <a-button> <a-icon type="upload" /> 上传图片 </a-button>
        </a-upload>
        <br>
        <h5>全景图类型</h5>
        <a-select v-model="imageType" style="width: 150px">
          <a-select-option :value="option.id" v-for="option in imageTypeOptions" :key="option.id">{{option.text}}</a-select-option>
        </a-select>
        <h5>上传全景图</h5>
        <a-upload
          name="file"
          :multiple="false"
          :action="$api.uploadUrl"
          list-type="picture"
          :headers="headers"
          :data="otherParams"
          @change="(e) => handleChange(e, 'image')"
          :file-list="fileList"
          v-if="imageType === 1"
        >
          <a-button> <a-icon type="upload" /> 上传图片 </a-button>
        </a-upload>
        <a-row type="flex" v-else>
          <a-col v-for="(item, index) in uploadItems" :key="index" :span="8">
            <div class="upload-item">
              <a-upload
                :multiple="false"
                :data="typeParams"
                listType="picture-card"
                :action="$api.uploadUrl2"
                :headers="headers"
                :showUploadList="false"
                :before-upload="(e) => beforeUpload(e, item)"
                @preview="handlePreview"
                @remove="handleRemove"
                @change="e => handleChange(e, 'image', index)"
              >
                <div v-if="item.path" class="upload-img-wrapper" @click.stop>
                  <img class="image-pic" :src="item.path" />
                  <div class="upload-img-view">
                    <div class="ant-upload-list-item-actions-bg"></div>
                    <div class="ant-upload-list-item-actions">
                      <a-icon
                        type="eye"
                        class="upload-control-icon"
                        @click="handlePreview(item.path)"
                      />
                      <a-icon
                        type="delete"
                        class="upload-control-icon"
                        @click="handleRemove(index)"
                      />
                    </div>
                  </div>
                </div>
                <div v-else>
                  <a-icon :type="item.loading ? 'loading' : 'plus'" />
                  <div class="ant-upload-text">上传</div>
                </div>
              </a-upload>
              <div class="upload-item-text">{{item.name}}</div>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false" width="800px">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>
<script>
import { baseURL } from '@/utils/network'
const token = localStorage.getItem('token')
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: '添加场景',
      headers: {
        'Authorization': token
      },
      fileList: [],
      fileListCover: [],
      fileListPreview: [],
      otherParams: {
        name: 'test'
      },
      // typeId   type: 'u'
      typeParams: {
        name: 'test'
      },
      form: this.$form.createForm(this),
      sceneName: '',
      imageTypeOptions: [
        {
          id: 1,
          text: '球形全景图'
          // text: 'Sphere',
        },
        {
          id: 2,
          text: '立方体全景图'
          // text: 'Cube'
        }
      ],
      imageType: 1,
      previewImage: '',
      previewVisible: false,
      uploadItems: [
        {
          side: 'u',
          name: '上',
          path: ''
        },
        {
          side: 'd',
          name: '下',
          path: ''
        },
        {
          side: 'l',
          name: '左',
          path: ''
        },
        {
          side: 'r',
          name: '右',
          path: ''
        },
        {
          side: 'f',
          name: '前',
          path: ''
        },
        {
          side: 'b',
          name: '后',
          path: ''
        }
      ],
    }
  },
  methods: {
    getImagePrefix() {
      for(let x in this.uploadItems) {
        var item = this.uploadItems[x]
        if(item.path) {
          var parts = item.path.split('/')
          var prefix = parts.pop().split('_')[0]
          return prefix
        }
      }
      return ''
    },
    beforeUpload(file, item) {
      this.typeParams = {
        name: 'test',
        type: item.side,
        typeId: this.getImagePrefix()
      }
      return true;
    },
    // modal confirm
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if(!err) {
          // console.log('values', values)
          if(this.fileListCover.length === 0) {
            this.$message.warning('请先上传封面图')
            return
          }
          if(this.imageType == 1 && this.fileList.length === 0) {
            this.$message.warning('请先上传全景图')
            return
          } else if(this.imageType == 2) {
            for(let x in this.uploadItems) {
              var item = this.uploadItems[x]
              if(!item.path) {
                this.$message.warning('请补全立方体全景图片')
                return
              }
            }
          }
          
          var thumburl = this.fileListCover[0].url
          var previewurl = this.fileListPreview.length > 0 ? this.fileListPreview[0].url : ''
          var imageurl = this.fileList.length > 0 ? this.fileList[0].url : ''
          var images = this.imageType === 2 ? this.uploadItems.map(item => {
            return {
              imageurl: item.path,
              side: item.side
            }
          }) : null
          thumburl = thumburl ? thumburl.replace(':8001', ':8002') : ''
          imageurl = imageurl ? imageurl.replace(':8001', ':8002') : ''
          previewurl = previewurl ? previewurl.replace(':8001', ':8002') : ''
          images = images ? images.map(item => {
            item.imageurl = item.imageurl.replace(':8001', ':8002')
            return item
          }) : images
          this.$emit('confirm', {
            sceneName: values.sceneName,
            imageType: this.imageType,
            thumburl,
            imageurl,
            previewurl,
            images,
          })
        }
      })
    },
    afterClose() {
      this.form.resetFields()
      this.fileList = []
      this.fileListCover = []
      this.fileListPreview = []
      this.uploadItems = this.uploadItems.map(item => {
        item.path = ''
        return item
      })
      this.title = '添加场景'
    },
    setFileList(value) {
      console.log('set', value)
      if(value.imageurl) {
        this.fileList = [
          {
            url: value.imageurl,
            uid: '-1',
            name: 'image.png',
            status: 'done'
          }
        ]
      }
      if(value.thumburl) {
        this.fileListCover = [
          {
            url: value.thumburl,
            uid: '-1',
            name: 'cover.png',
            status: 'done'
          }
        ]
      }
      if(value.previewurl) {
        this.fileListPreview = [
          {
            url: value.previewurl,
            uid: '-1',
            name: 'preview.png',
            status: 'done'
          }
        ]
      }
      if(value.images) {
        this.uploadItems = this.uploadItems.map(item => {
          var imageItem = value.images.find(imageItem => {
            return imageItem.side === item.side
          })
          if(imageItem) {
            item.path = imageItem.imageurl
          }
          return item
        })
      }
      this.imageType = value.imageType ? value.imageType : 1
      this.$nextTick(() => {
        this.form.setFieldsValue({
          sceneName: value.sceneName
        })
      })
      this.title = '编辑场景'
    },
    // 单据照片预览
    handlePreview(path) {
      this.previewImage = path
      this.previewVisible = true
    },
    handleRemove(index) {
      this.uploadItems[index].path = ''
    },
    handleChange(info, type, index) {
      // console.log('info', info, type, index)
      let { file, fileList } = info;
      fileList = fileList.slice(-1);
      fileList = fileList.map(file => {
        if (file.response && file.response.path) {
          var path = file.response.path
          var idx = path.indexOf('/file')
          path = 'https://vr.gdyfpt.com' + path.slice(idx)
          file.url = path
        }
        return file;
      });

      if(type === 'cover') {
        this.fileListCover = fileList
      } else if(type === 'preview') {
        this.fileListPreview = fileList
      } else {
        if(this.imageType === 1) {
          this.fileList = fileList
        } else {
          let item = this.uploadItems[index]
          if (file.status === 'uploading') {
            item.path = ''
            item.loading = true
            this.$set(this.uploadItems, index, item)
            return
          }
          if (file.status === 'done') {
            if (file.response && file.response.path) {
              var path = file.response.path
              var idx = path.indexOf('/file')
              item.path = 'https://vr.gdyfpt.com' + path.slice(idx)
              item.loading = false
              this.$set(this.uploadItems, index, item)
              this.$message.success(`${file.name} 上传成功`)
            } else {
              this.$message.error(`${file.name} 上传失败`)
            }
          }
        }
      }
      
    }
  }
}
</script>
<style scoped lang="scss">
h5 {
  line-height: 36px;
}
.upload-img-wrapper {
  position: relative;

  .upload-img-view {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transition: all 0.3s;
    width: 100%;
    height: 100%;
    &:hover {
      opacity: 1;
    }
    .upload-control-icon {
      font-size: 16px;
      color: #fff;
      padding: 6px;
    }
  }
  .ant-upload-list-item-actions-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.65);
    z-index: 9;
  }
  .ant-upload-list-item-actions {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 10;
    white-space: nowrap;
    transform: translate(-50%, -50%);
    // opacity: 0;
    transition: all 0.3s;
  }
}
.upload-item {
  margin-bottom: 15px;
}
.upload-item-text {
  width: 104px;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
}
</style>


// WEBPACK FOOTER //
// AddScene.vue?dee64312